import React, { useEffect, useRef, useState } from 'react';
import { Badge } from './ui/badge';
import { Card } from './ui/card';

const Skills = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  const skillCategories = [
    {
      id: 'skills-1',
      title: 'Academic & Research Expertise',
      skills: [
        'Applied Linguistics',
        'Corpus Linguistics & Corpus Stylistics',
        'Discourse Analysis & Critical Discourse Analysis',
        'Literary Stylistics & Narratology',
        'Comparative Religious and Narrative Studies',
        'Phonetics & Phonology'
      ]
    },
    {
      id: 'skills-2',
      title: 'Teaching & Curriculum Development',
      skills: [
        'Graduate & Doctoral-Level Teaching',
        'Course Design (MPhil & PhD Programmes)',
        'Research Methodology Instruction',
        'Assessment in Language Learning',
        'Academic Writing & Genre Studies'
      ]
    },
    {
      id: 'skills-3',
      title: 'Leadership & Administration',
      skills: [
        'Academic Leadership & Governance',
        'Faculty & Department Management',
        'Quality Assurance & Accreditation',
        'Strategic Planning in Higher Education',
        'Research Programme Development'
      ]
    },
    {
      id: 'skills-4',
      title: 'Scholarly & Professional Service',
      skills: [
        'Journal Editing & Editorial Board Membership',
        'Conference Organization & Plenary Speaking',
        'Doctoral Supervision & Thesis Evaluation',
        'International Research Collaboration'
      ]
    }
  ];

  return (
    <section id="skills" ref={sectionRef} className="py-16 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-3">
            Skills & Expertise
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-600 to-cyan-500 mx-auto"></div>
        </div>

        {/* Skills Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {skillCategories.map((category) => (
            <Card
              key={category.id}
              className={`p-6 bg-white border-gray-200 hover:shadow-xl transition-all duration-500 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              <h3 className="font-bold text-lg text-blue-900 mb-4 pb-2 border-b-2 border-blue-600">
                {category.title}
              </h3>
              <div className="flex flex-wrap gap-2">
                {category.skills.map((skill, skillIndex) => (
                  <Badge
                    key={skillIndex}
                    variant="secondary"
                    className="bg-blue-50 text-blue-700 hover:bg-blue-600 hover:text-white transition-colors px-3 py-1 text-xs font-medium rounded-md"
                  >
                    {skill}
                  </Badge>
                ))}
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;